<div class="p-2">
  <!-- Title -->
  <div class="row pb-2">
    <div class="col-10 h5 text-muted p-0">Coupon Details</div>
    <div class="col-2 p-0">
      <button type="button" class="btn btn-secondary btn-sm text-white float-end fw-bold" title="Back" (click)="onBackClick()">
        <i-bs class="text-light" name="arrowLeft" width="22" height="22"></i-bs>
      </button>
    </div>
  </div>

  <div class="row bg-light p-2">
    <div class="col-12">

      <div class="row bg-white mt-0 pt-2 pb-2">
        <!-- Coupon info -->
        <div class="col-12">
          <div class="row g-0">
            <div class="col-1">
              <img class="img-fluid rounded-start" [src]="selectedCouponDetails?.coupon.coupon_image" alt="...">
            </div>
            <div class="col-11">
              <h5 class="text-danger" *ngIf="selectedCouponDetails?.coupon.coupon_discount.discount_id == 1">&nbsp;&nbsp;Save ${{ selectedCouponDetails?.coupon.coupon_discount.discount_lower }}</h5>
              <h5 class="text-danger" *ngIf="selectedCouponDetails?.coupon.coupon_discount.discount_id == 2">&nbsp;&nbsp;Save {{ selectedCouponDetails?.coupon.coupon_discount.discount_lower }}%</h5>
              <h5 class="text-danger" *ngIf="selectedCouponDetails?.coupon.coupon_discount.discount_id == 3">&nbsp;&nbsp;Buy {{ selectedCouponDetails?.coupon.coupon_discount.discount_lower }} Get {{ selectedCouponDetails?.coupon.coupon_discount.discount_upper }}</h5>

              <p class="text-muted">&nbsp;&nbsp;&nbsp;{{ selectedCouponDetails?.coupon.coupon_title }}</p>
            </div>
          </div>
        </div>

        <!-- Products -->
        <div class="col-12">
          <span class="text-muted fw-bold">
            Products
            <i-bs
              name="infoCircle"
              class="text-primary"
              tooltip="Pick products to consider in reports"
              placement="top">
            </i-bs>
          </span>
        </div>

        <div class="col-12">
          <ng-multiselect-dropdown
            [placeholder]="'Select'"
            [settings]="productSelectionSettings"
            [data]="selectedCouponProducts"
            [(ngModel)]="selectedProducts"
            (onSelect)="onProductSelect($event)"
            (onDeSelect)="onProductDeSelect($event)">
          </ng-multiselect-dropdown>
        </div>
      </div>

      <!-- Redemption data -->
      <div class="row bg-white mt-2 pt-2 pb-2">
        <div class="col-12">

          <!-- Loader -->
          <div class="row mt-4 mb-4" *ngIf="couponRedemptionReportLoading === true">
            <div class="col-12 text-center">
              <div class="spinner-border text-info mt-4 mb-4" ></div>
            </div>
          </div>

          <!-- Empty message -->
          <div class="row mt-4 mb-4" *ngIf="couponRedemptionReportLoading === false && couponRedemptionData.length == 0">
            <div class="col-12 text-center">
              <div class="mt-4 pt-4">
                <i-bs class="text-black-50 mt-4 pt-4" name="barChart" width="30" height="30"></i-bs>
                <div class="col-12 text-center text-black-50 mb-4 pb-4">Data not found</div>
              </div>
            </div>
          </div>

          <!-- Line chart -->
          <div class="row" *ngIf="couponRedemptionReportLoading === false && couponRedemptionData?.datasets.length > 0">
            <div class="col-12 text-center">
              <app-chartjs-line [chartHeight]="'150'" [chartData]="couponRedemptionData"></app-chartjs-line>
            </div>
          </div>

        </div>
      </div>

      <!-- Coupon report -->
      <div class="row bg-white mt-2 pt-2 pb-2">
        <div class="col-12">

          <!-- Report and compare dates -->
          <div class="row mt-3">
            <div class="col-12 text-muted text-left">
              <span class="date-label report-data-color">Report Data: {{ reportateRange[0] | date : 'MMM d, y' }}&nbsp;&nbsp;to&nbsp;&nbsp;{{ reportateRange[1] | date : 'MMM d, y' }} ({{ reportDays }} days)</span>
              &nbsp;&nbsp;-&nbsp;&nbsp;
              <span class="date-label compare-data-color">Compare Data: {{ compareDateRange[0] | date : 'MMM d, y' }}&nbsp;&nbsp;to&nbsp;&nbsp;{{ compareDateRange[1] | date : 'MMM d, y' }} (Last {{ compareDays }} days)</span>
              <span class="date-label-change text-danger cursor-pointer" (click)="openCalendarModal(comparedDateChangeModal)">&nbsp;Change</span>
            </div>
          </div>

          <!-- Sales amount, Basket count and Avg. basket size -->
          <div class="row border-bottom mt-4 pb-2">
            <div class="col-4">
              <div class="fs-6 fw-bold text-muted">
                Sales Amount
                <i-bs
                  name="infoCircle"
                  class="text-primary"
                  tooltip="Sum of item amounts"
                  placement="top">
                </i-bs>
              </div>
              <div class="mt-2">
                <span class="h4">{{ couponData?.reportDataSelectedStore[0]?.item_amount | currency }}</span>
                &nbsp;&nbsp;&nbsp;
                <span [ngClass]="couponData?.salesAmountPercentageChange >= 0 ? 'h4 text-secondary' : 'h4 text-danger'">
                  {{ couponData?.salesAmountPercentageChange | number : '1.0-2' }}%
                  <i-bs class="text-secondary" name="arrowUp" *ngIf="couponData?.salesAmountPercentageChange >= 0"></i-bs>
                  <i-bs class="text-danger" name="arrowDown" *ngIf="couponData?.salesAmountPercentageChange < 0"></i-bs>
                </span>
              </div>
            </div>
            <div class="col-4">
              <div class="fs-6 fw-bold text-muted">
                Basket Count
                <i-bs
                  name="infoCircle"
                  class="text-primary"
                  tooltip="Total number of transactions"
                  placement="top">
                </i-bs>
              </div>
              <div class="mt-2">
                <span class="h4">{{ couponData?.reportDataSelectedStore[0]?.basket_count | number : '1.0-2' }}</span>
                &nbsp;&nbsp;&nbsp;
                <span [ngClass]="couponData?.basketCountPercentageChange >= 0 ? 'h4 text-secondary' : 'h4 text-danger'">
                  {{ couponData?.basketCountPercentageChange | number : '1.0-2' }}%
                  <i-bs class="text-secondary" name="arrowUp" *ngIf="couponData?.basketCountPercentageChange >= 0"></i-bs>
                  <i-bs class="text-danger" name="arrowDown" *ngIf="couponData?.basketCountPercentageChange < 0"></i-bs>
                </span>
              </div>
            </div>
            <div class="col-4">
              <div class="fs-6 fw-bold text-muted">
                Avg. Basket Size
                <i-bs
                  name="infoCircle"
                  class="text-primary"
                  tooltip="Avg. of basket total/basket count"
                  placement="top">
                </i-bs>
              </div>
              <div class="mt-2">
                <span class="h4">{{ couponData?.reportDataSelectedStore[0]?.avg_basket_size | currency }}</span>
                &nbsp;&nbsp;&nbsp;
                <span [ngClass]="couponData?.avgBasketSizePercentageChange >= 0 ? 'h4 text-secondary' : 'h4 text-danger'">
                  {{ couponData?.avgBasketSizePercentageChange | number : '1.0-2' }}%
                  <i-bs class="text-secondary" name="arrowUp" *ngIf="couponData?.avgBasketSizePercentageChange >= 0"></i-bs>
                  <i-bs class="text-danger" name="arrowDown" *ngIf="couponData?.avgBasketSizePercentageChange < 0"></i-bs>
                </span>
              </div>
            </div>
          </div>

          <!-- Loader -->
          <div class="row mt-4 mb-4" *ngIf="couponDetailedReportLoading === true">
            <div class="col-12 text-center">
              <div class="spinner-border text-info mt-4 mb-4" ></div>
            </div>
          </div>

          <!-- Empty message -->
          <div class="row mt-4 mb-4" *ngIf="couponDetailedReportLoading === false && couponData?.reportDataAll.length == 0 && couponData?.compareDataAll.length == 0">
            <div class="col-12 text-center">
              <div class="mt-4 pt-4" >
                <i-bs class="text-black-50 mt-4 pt-4" name="barChart" width="30" height="30"></i-bs>
                <div class="col-12 text-center text-black-50 mb-4 pb-4">Data not found</div>
              </div>
            </div>
          </div>

          <!-- Store data -->
          <div class="row mt-3 mb-3" *ngIf="couponDetailedReportLoading === false && (couponData?.reportDataAll.length > 0 || couponData?.compareDataAll.length > 0)">
            <div class="col-12">

              <!-- Header -->
              <div class="row store-data-header-row m-1">
                <div class="col-6">&nbsp;</div>
                <div class="col-2 title text-muted">Sales Amount</div>
                <div class="col-2 title text-muted">Sales Difference</div>
                <div class="col-2 title text-muted">Units Sold</div>
              </div>

               <!-- Stores -->
               <div class="row store-data-row" *ngFor="let store of couponData?.storeData">
                <div class="col-6">
                  <div class="title text-muted">{{ store.store_name }}</div>
                  <app-chartjs-bar [chartHeight]="store.chartHeight" [chartData]="store.chartData"></app-chartjs-bar>
                </div>
                <div class="col-2">
                  <div class="value text-muted pt-4">{{ store.report_sales_amount | currency }}</div>
                  <div class="value text-muted pt-1">{{ store.compare_sales_amount | currency }}</div>
                </div>
                <div class="col-2">
                  <div [ngClass]="store.sales_diff >= 0 ? 'value text-secondary fw-bold pt-4' : 'value text-danger fw-bold pt-4'">
                    {{ store.sales_diff | number : '1.0-2' }}%
                    <i-bs class="text-secondary" name="arrowUp" *ngIf="store.sales_diff >= 0"></i-bs>
                    <i-bs class="text-danger" name="arrowDown" *ngIf="store.sales_diff < 0"></i-bs>
                  </div>
                </div>
                <div class="col-2 value text-muted">
                  <div class="value text-muted pt-4">{{ store.report_units_sold | number : '1.0-2' }}</div>
                  <div class="value text-muted pt-1">{{ store.compare_units_sold | number : '1.0-2' }}</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</div>

<!-- Compare Date Change Popover
<ng-template #comparedDateChangePopContent>
  <div class="container popover-outer compared-date-change-popover p-0">
    <ul class="list-group list-group-flush">
      <li class="list-group-item border-0 m-0 p-0">
        <span class="link text-muted" (click)="changeCompareMode()">Previous year</span>
      </li>
      <li class="list-group-item border-0 m-0 p-0">
        <span class="link text-muted" (click)="changeCompareMode()">Previous days</span>
      </li>
    </ul>
  </div>
</ng-template>-->

<!-- Compare Date Change Modal-->
<ng-template #comparedDateChangeModal>
  <div class="modal-body text-center">
    <bs-daterangepicker-inline
      [bsValue]="compareDateRange"
      [bsConfig]="calendarConfig"
      [minDate]="calendarMinDate"
      [maxDate]="calendarMaxDate"
      (bsValueChange)="onCalendarValueChange($event)">
    </bs-daterangepicker-inline>
  </div>
</ng-template>
